export const REPORT_COMMENT_DEBOUNCE_TIME = 3000;

export const NOT_APPLICABLE = 'N/A';
